import { useState } from "react";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";

const galleryImages = [
  {
    id: 1,
    src: "https://storage.readdy-site.link/project_files/bc732e62-3228-48e2-a085-f6cbb8bbab95/a2451882-81d5-4b8e-b8eb-d0168cdfe08d_RR-6639.jpeg?v=e9394542f5ee666a9b0674cd0aa39fbf",
    alt: "Table Privé — Curated dining atmosphere",
    span: "tall",
  },
  {
    id: 2,
    src: "https://public.readdy.ai/ai/img_res/bfcf36fccf1cc5c44e60e0bb795ed195.jpg",
    alt: "Champagne flutes on candlelit dining table",
    span: "normal",
  },
  {
    id: 3,
    src: "https://storage.readdy-site.link/project_files/bc732e62-3228-48e2-a085-f6cbb8bbab95/955f42ff-7543-477e-9a0e-c18e02c94d14_RR-6981.jpeg?v=9965584c9a2749d3bd660637d9dbc232",
    alt: "Table Privé — Refined table setting detail",
    span: "normal",
  },
  {
    id: 4,
    src: "https://storage.readdy-site.link/project_files/bc732e62-3228-48e2-a085-f6cbb8bbab95/52a402c3-df68-4ca1-903c-d7d4f920671a_RR-6954.jpeg?v=67175114392a7165b8e3dab1f29f2081",
    alt: "Table Privé — Private dining moment",
    span: "tall",
  },
  {
    id: 5,
    src: "https://readdy.ai/api/search-image?query=luxury%20floral%20centerpiece%20arrangement%20deep%20burgundy%20roses%20white%20peonies%20eucalyptus%20greenery%20tall%20glass%20vase%20on%20dining%20table%20candlelight%20bokeh%20background%20editorial%20luxury%20event%20floristry%20warm%20tones%20atmospheric&width=600&height=700&seq=gal005&orientation=portrait",
    alt: "Luxury floral centerpiece with deep burgundy roses",
    span: "normal",
  },
  {
    id: 6,
    src: "https://storage.readdy-site.link/project_files/bc732e62-3228-48e2-a085-f6cbb8bbab95/faa05908-d37d-49e3-a47f-37f39c5694d9_RR-7009.jpeg?v=b70681a02cdaafa4cca718e062236927",
    alt: "Table Privé — Scene of atmosphere",
    span: "normal",
  },
  {
    id: 7,
    src: "https://storage.readdy-site.link/project_files/bc732e62-3228-48e2-a085-f6cbb8bbab95/3b97b67b-a46b-4f9d-88e3-f287c87ed53f_IMG_7075.jpeg?v=d9a9efe72431b1ed2e579fd1a509ba17",
    alt: "Table Privé — Intimate setting",
    span: "tall",
  },
  {
    id: 8,
    src: "https://storage.readdy-site.link/project_files/bc732e62-3228-48e2-a085-f6cbb8bbab95/86622fbf-c61f-4977-901d-2ca5387eccf9_IMG_7076.jpeg?v=6a9c422ee41a5637c9b91bce6f0ea58d",
    alt: "Table Privé — Curated moment",
    span: "normal",
  },
  {
    id: 9,
    src: "https://readdy.ai/api/search-image?query=luxury%20outdoor%20private%20dining%20setup%20terrace%20alfresco%20table%20dressed%20with%20white%20linen%20crystal%20candles%20lanterns%20evening%20golden%20hour%20warm%20atmospheric%20light%20greenery%20foliage%20cinematic%20editorial%20exclusive%20bespoke%20event%20photography&width=600&height=450&seq=gal009&orientation=landscape",
    alt: "Alfresco terrace dining in golden hour light",
    span: "normal",
  },
  {
    id: 10,
    src: "https://storage.readdy-site.link/project_files/bc732e62-3228-48e2-a085-f6cbb8bbab95/67c870b7-01ed-4758-bd90-4c603e94b2d7_RR-6560.jpeg?v=29b692ffdccb1c5b7556af64c12227cc",
    alt: "Table Privé — Scene of refinement",
    span: "tall",
  },
  {
    id: 11,
    src: "https://storage.readdy-site.link/project_files/bc732e62-3228-48e2-a085-f6cbb8bbab95/e127ab87-1ab1-4068-b1f2-c3ea53a6ef50_IMG_6461.jpeg?v=3b22c0950aa7a38bff2a3444e1985bd5",
    alt: "Table Privé — Composed with care",
    span: "normal",
  },
  {
    id: 12,
    src: "https://storage.readdy-site.link/project_files/bc732e62-3228-48e2-a085-f6cbb8bbab95/d6a56cb4-9fad-41ff-8cf7-af4d13a21ca0_IMG_6458.jpeg?v=1198fffcfa10aea192a7a005a5173da8",
    alt: "Table Privé — Atmosphere and texture",
    span: "normal",
  },
  {
    id: 13,
    src: "https://storage.readdy-site.link/project_files/bc732e62-3228-48e2-a085-f6cbb8bbab95/fe99abe2-3fe1-4c77-9907-c25d46cd8f65_IMG_6451.jpeg?v=b44222fea33ab5a1e83567403dd7e15f",
    alt: "Table Privé — Deliberate detail",
    span: "tall",
  },
  {
    id: 14,
    src: "https://readdy.ai/api/search-image?query=elegant%20wine%20pouring%20moment%20sommelier%20hand%20pouring%20red%20wine%20into%20crystal%20glass%20dark%20moody%20background%20warm%20amber%20light%20close%20up%20luxury%20hospitality%20service%20moment%20cinematic%20editorial%20photography%20refined%20details&width=600&height=450&seq=gal006&orientation=landscape",
    alt: "Sommelier pouring fine wine into crystal glass",
    span: "normal",
  },
  {
    id: 15,
    src: "https://readdy.ai/api/search-image?query=intimate%20candlelit%20dining%20table%20for%20two%20set%20for%20a%20private%20luxury%20dinner%20roses%20scattered%20petals%20crystal%20wine%20glasses%20silver%20candlesticks%20white%20linen%20dark%20atmospheric%20moody%20warm%20editorial%20cinematic%20photography%20bespoke%20romance%20exclusive&width=600&height=700&seq=gal010b&orientation=portrait",
    alt: "Intimate candlelit dining table set for two",
    span: "normal",
  },
];

type ImageItem = typeof galleryImages[0];

function GalleryImage({ image, onClick }: { image: ImageItem; onClick: (img: ImageItem) => void }) {
  const heightClass =
    image.span === "tall"
      ? "h-[520px]"
      : image.span === "wide"
      ? "h-[320px]"
      : "h-[380px]";

  return (
    <div
      className={`relative overflow-hidden group cursor-pointer ${
        image.span === "wide" ? "col-span-2" : "col-span-1"
      }`}
      onClick={() => onClick(image)}
    >
      <div className={`relative w-full ${heightClass} overflow-hidden`}>
        <img
          src={image.src}
          alt={image.alt}
          loading="lazy"
          onError={(e) => {
            (e.currentTarget as HTMLImageElement).src =
              "https://readdy.ai/api/search-image?query=luxury%20dining%20table%20atmospheric%20warm%20candlelight%20minimal%20elegant&width=600&height=500&seq=fallback001&orientation=landscape";
          }}
          className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-all duration-500" />
        <div className="absolute inset-0 flex items-end p-6 opacity-0 group-hover:opacity-100 transition-opacity duration-500">
          <div className="h-px w-8 bg-[#C9A961]" />
        </div>
      </div>
    </div>
  );
}

function LightboxModal({ image, onClose, onPrev, onNext }: {
  image: ImageItem;
  onClose: () => void;
  onPrev: () => void;
  onNext: () => void;
}) {
  return (
    <div
      className="fixed inset-0 z-[100] bg-black/95 flex items-center justify-center"
      onClick={onClose}
    >
      <button
        className="absolute top-6 right-8 w-10 h-10 flex items-center justify-center text-white/60 hover:text-white transition-colors cursor-pointer z-10"
        onClick={onClose}
        aria-label="Close"
      >
        <i className="ri-close-line text-2xl" />
      </button>

      <button
        className="absolute left-6 top-1/2 -translate-y-1/2 w-10 h-10 flex items-center justify-center text-white/50 hover:text-white transition-colors cursor-pointer z-10"
        onClick={(e) => { e.stopPropagation(); onPrev(); }}
        aria-label="Previous"
      >
        <i className="ri-arrow-left-line text-xl" />
      </button>

      <button
        className="absolute right-6 top-1/2 -translate-y-1/2 w-10 h-10 flex items-center justify-center text-white/50 hover:text-white transition-colors cursor-pointer z-10"
        onClick={(e) => { e.stopPropagation(); onNext(); }}
        aria-label="Next"
      >
        <i className="ri-arrow-right-line text-xl" />
      </button>

      <div
        className="max-w-4xl max-h-[85vh] px-4"
        onClick={(e) => e.stopPropagation()}
      >
        <img
          src={image.src}
          alt={image.alt}
          className="max-w-full max-h-[85vh] object-contain"
        />
        <p className="text-center text-white/40 text-xs tracking-[0.2em] uppercase font-light mt-4">
          {image.alt}
        </p>
      </div>
    </div>
  );
}

export default function GalleryPage() {
  const [lightbox, setLightbox] = useState<ImageItem | null>(null);

  const currentIndex = lightbox ? galleryImages.findIndex((img) => img.id === lightbox.id) : -1;

  const openLightbox = (img: ImageItem) => setLightbox(img);
  const closeLightbox = () => setLightbox(null);
  const prevImage = () => {
    if (currentIndex > 0) setLightbox(galleryImages[currentIndex - 1]);
    else setLightbox(galleryImages[galleryImages.length - 1]);
  };
  const nextImage = () => {
    if (currentIndex < galleryImages.length - 1) setLightbox(galleryImages[currentIndex + 1]);
    else setLightbox(galleryImages[0]);
  };

  return (
    <main className="min-h-screen bg-[#FAF8F5]">
      <Navbar />

      {/* Hero */}
      <section className="relative h-[55vh] min-h-[420px] flex items-end overflow-hidden">
        <div className="absolute inset-0 w-full h-full">
          <img
            src="https://readdy.ai/api/search-image?query=wide%20panoramic%20view%20of%20luxurious%20private%20dining%20room%20setting%20long%20table%20dressed%20in%20white%20linen%20tall%20elegant%20candles%20crystal%20glasses%20dark%20dramatic%20warm%20atmospheric%20cinematic%20interior%20photography%20editorial%20luxury%20hospitality%20moody%20black%20background&width=1600&height=900&seq=galHero001&orientation=landscape"
            alt="Table Privé Gallery — Luxury dining atmosphere"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/70" />
        </div>

        <div className="relative z-10 w-full px-8 md:px-20 pb-16 md:pb-20">
          <div className="flex items-center gap-4 mb-5">
            <div className="h-px w-10 bg-[#C9A961]" />
            <span className="text-[#C9A961] tracking-[0.25em] uppercase text-xs font-light">
              Visual Journal
            </span>
          </div>
          <h1 className="font-serif text-white text-5xl md:text-7xl font-light tracking-tight leading-none">
            The Gallery
          </h1>
          <p className="mt-4 text-white/60 font-light text-sm tracking-widest uppercase">
            Moments of refinement, captured
          </p>
        </div>
      </section>

      {/* Intro line */}
      <section className="py-14 md:py-20 px-8 md:px-20 max-w-4xl">
        <p className="font-serif text-[#2C2420] text-xl md:text-2xl leading-relaxed font-light tracking-wide">
          Every table tells a story. These are ours — moments of atmosphere, texture, and quiet luxury, 
          composed with deliberate care.
        </p>
      </section>

      {/* Masonry Grid */}
      <section className="px-6 md:px-14 pb-24">
        <div className="columns-1 sm:columns-2 lg:columns-3 gap-4">
          {galleryImages.map((image) => {
            const heightClass =
              image.span === "tall" ? "h-[500px]" : "h-[360px]";
            return (
              <div
                key={image.id}
                className="break-inside-avoid mb-4 relative overflow-hidden group cursor-pointer"
                onClick={() => openLightbox(image)}
              >
                <div className={`relative w-full ${heightClass} overflow-hidden bg-[#EDE8E1]`}>
                  <img
                    src={image.src}
                    alt={image.alt}
                    loading="lazy"
                    onError={(e) => {
                      const target = e.currentTarget as HTMLImageElement;
                      if (!target.dataset.errored) {
                        target.dataset.errored = "true";
                        target.src =
                          "https://readdy.ai/api/search-image?query=luxury%20intimate%20private%20dining%20candlelight%20warm%20moody%20editorial%20elegant%20atmosphere&width=600&height=700&seq=fallback002&orientation=portrait";
                      }
                    }}
                    className="w-full h-full object-cover object-center transition-transform duration-700 group-hover:scale-105 block"
                  />
                  <div className="absolute inset-0 bg-black/0 group-hover:bg-black/25 transition-all duration-500" />
                  <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                    <div className="w-10 h-10 flex items-center justify-center border border-white/60">
                      <i className="ri-add-line text-white text-lg" />
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </section>

      {/* Bottom CTA */}
      <section className="py-20 md:py-28 px-8 md:px-20 text-center border-t border-[#E8E2D9]">
        <div className="flex items-center justify-center gap-4 mb-8">
          <div className="h-px w-12 bg-[#C9A961]/60" />
          <span className="text-[#C9A961] tracking-[0.25em] uppercase text-xs font-light">
            Begin Your Experience
          </span>
          <div className="h-px w-12 bg-[#C9A961]/60" />
        </div>
        <h2 className="font-serif text-[#1A1A1A] text-3xl md:text-5xl font-light mb-6 leading-tight">
          Commission Your Table
        </h2>
        <p className="text-[#8A7F74] font-light text-sm md:text-base max-w-xl mx-auto leading-relaxed mb-10 tracking-wide">
          Each Table Privé experience is designed entirely around you — your vision, your occasion, your standard.
        </p>
        <a
          href="/experiences"
          className="inline-flex items-center gap-3 px-10 py-4 border border-[#1A1A1A] text-[#1A1A1A] text-xs tracking-[0.2em] uppercase font-light hover:bg-[#1A1A1A] hover:text-[#FAF8F5] transition-all duration-300 cursor-pointer whitespace-nowrap"
        >
          Submit a Private Inquiry
          <i className="ri-arrow-right-line text-sm" />
        </a>
      </section>

      <Footer />

      {/* Lightbox */}
      {lightbox && (
        <LightboxModal
          image={lightbox}
          onClose={closeLightbox}
          onPrev={prevImage}
          onNext={nextImage}
        />
      )}
    </main>
  );
}
